(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zz-project-detail"]) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.zzcReady) return;
      root.dataset.zzcReady = '1';

      // Timeline: light up once, when it comes into view.
      var tl = root.querySelector('[data-zzc-tl]');
      if (tl) {
        if (!('IntersectionObserver' in window)) { tl.classList.add('is-in'); }
        else {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) { tl.classList.add('is-in'); io.disconnect(); } });
          }, { rootMargin: '0px 0px -20% 0px' });
          io.observe(tl);
        }
      }

      // Lightbox
      var lb = root.querySelector('[data-zzc-lb]');
      if (!lb || typeof lb.showModal !== 'function') return;
      var data = [];
      try { data = JSON.parse(lb.querySelector('[data-zzc-photos]').textContent); } catch (e) {}
      var img = lb.querySelector('[data-zzc-lbimg]');
      var cap = lb.querySelector('[data-zzc-lbcap]');
      var count = lb.querySelector('[data-zzc-count]');
      var idx = 0, opener = null;
      function show(i) {
        if (!data.length) return;
        idx = (i + data.length) % data.length;
        img.src = data[idx].src; img.alt = data[idx].alt;
        cap.textContent = data[idx].alt;
        count.textContent = (idx + 1) + ' of ' + data.length;
      }
      root.querySelectorAll('[data-zzc-open]').forEach(function (b) {
        b.addEventListener('click', function () { opener = b; show(parseInt(b.dataset.zzcOpen, 10) || 0); lb.showModal(); });
      });
      lb.querySelector('[data-zzc-prev]').addEventListener('click', function () { show(idx - 1); });
      lb.querySelector('[data-zzc-next]').addEventListener('click', function () { show(idx + 1); });
      lb.querySelector('[data-zzc-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('zzc__lbin')) lb.close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
      });
      lb.addEventListener('close', function () { if (opener) opener.focus(); });
    }
    function boot() { document.querySelectorAll('[data-zzc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
